if (!customElements.get('product-form-handler')) {
    class ProductFormHandler extends HTMLElement {
        constructor() {
            super();
            this.boundHandleSubmit = this.handleSubmit.bind(this);
        }

        connectedCallback() {
            this.form = this.querySelector('form[action*="/cart/add"]');
            this.submitButton = this.querySelector('button[type="submit"]');
            this.cartService = document.querySelector('cart-service');
            this.mainCart = document.getElementById('main-cart');
            this.overlay = document.getElementById('overlay');
            this.miniCart = document.getElementById('mini-cart');
            this.body = document.querySelector('body');
            this.navWrapper = document.getElementById('nav-wrapper');

            // Listen on form 'submit' (covers button click + Enter key).
            // Safe now that the cart wrapper <form id="cart"> is empty —
            // inner /cart/add forms are first-class siblings, not nested.
            // Idempotency flag prevents double-binding if connectedCallback fires
            // again (e.g. element moved between parents).
            if (this.form && !this._submitBound) {
                this.form.addEventListener('submit', this.boundHandleSubmit);
                this._submitBound = true;
            }
        }
        
        // Manage body scroll lock and padding (hO function)
        toggleBodyScroll(lock) {
            const scrollbarWidth = window.innerWidth - document.body.offsetWidth;
            
            if (lock) {
                document.body.classList.add('no-scroll');
                document.body.style.paddingRight = scrollbarWidth + 'px';
                if (this.navWrapper) {
                    this.navWrapper.style.paddingRight = scrollbarWidth + 'px';
                }
            } else {
                document.body.classList.remove('no-scroll');
                document.body.style.paddingRight = '0px';
                if (this.navWrapper) {
                    this.navWrapper.style.paddingRight = '0px';
                }
            }
        }
        
        // Manage Escape key listener (gp function)
        toggleEscapeListener(enable, callback) {
            if (callback) {
                this.escapeCallback = callback;
            }
            
            if (enable) {
                window.addEventListener('keydown', this.handleEscape.bind(this));
            } else {
                window.removeEventListener('keydown', this.handleEscape.bind(this));
            }
        }
        
        handleEscape(event) {
            if (event.key === 'Escape' && this.escapeCallback) {
                this.escapeCallback();
                window.removeEventListener('keydown', this.handleEscape.bind(this));
            }
        }
        
        closeMiniCart() {
            if (this.miniCart) {
                this.miniCart.classList.remove('open');
            }
            if (this.overlay) {
                this.overlay.classList.remove('open');
            }
            if (this.body) {
                this.body.style.removeProperty('overflow');
            }
            this.toggleBodyScroll(false);
        }

        async handleSubmit(event) {
            if (!this.form || !this.submitButton) return;
            
            event.preventDefault();
            event.stopPropagation();
            
            // UI feedback - loading state
            this.setLoadingState(true);
            
            // Prepare fetch options
            const formData = new FormData(this.form);
            const formVariantId = this.form.querySelector('input[name="id"]')?.value;
            formData.append('sections', 'main-cart');
            
            try {
                // Add to cart
                const response = await fetch(window.routes.cartAdd, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: formData
                });
                
                let cartData = await response.json();
                
                // Handle error response
                if (cartData.status) {
                    this.showError(cartData);
                    this.setLoadingState(false);
                    return;
                }
                
                // Parse main cart section
                let mainCartSection = new DOMParser().parseFromString(cartData.sections['main-cart'], 'text/html');
                
                console.log('AUTO ADD mainCartSection', mainCartSection);
                
                // Handle regular auto-add product (existing feature)
                const autoAddProduct = document.querySelector('input[data-auto-add-product]');
                if (autoAddProduct) {
                    console.log('AUTO ADD PRODUCT Found:', autoAddProduct);
                    const variantId = autoAddProduct.getAttribute('data-variant');
                    const autoAddInCart = mainCartSection.querySelector(`[data-cart-item-variant="${variantId}"]`);
                    
                    console.log('AUTO ADD auto_add_activated', autoAddInCart);
                    
                    if (variantId && formVariantId !== variantId && !autoAddInCart) {
                        console.log('AUTO ADD PRODUCT variant_id:', variantId);
                        
                        try {
                            const autoAddResponse = await fetch(window.routes.cartAdd, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    items: [{
                                        id: variantId,
                                        quantity: 1
                                    }],
                                    sections: 'main-cart,navigation-main'
                                })
                            });
                            cartData = await autoAddResponse.json();
                            console.log('AUTO ADD PRODUCT Success:', cartData);
                            mainCartSection = new DOMParser().parseFromString(cartData.sections['main-cart'], 'text/html');
                        } catch (error) {
                            console.warn('AUTO ADD PRODUCT Error:', error);
                        }
                    }
                }
                
                // Handle GWP auto-add/remove
                if (this.cartService) {
                    cartData = await this.cartService.processGWPActions(cartData);
                    mainCartSection = new DOMParser().parseFromString(cartData.sections['main-cart'], 'text/html');
                }
                
                console.log('AUTO ADD PRODUCT Not Found or already in cart:');
                
                // Clear error
                this.clearError();
                
                // Redirect to cart if UX is cart page
                if (window.cartStrings?.uxCart === 'cart') {
                    window.location.href = window.routes.cart;
                    return;
                }
                
                // Update cart UI
                if (this.mainCart) {
                    this.mainCart.classList.add('added');
                }
                
                if (this.cartService) {
                    this.cartService.renderItems(mainCartSection);
                }
                
                // Open mini-cart if UX is mini-cart. Not on the cart page: the page itself
                // already shows the updated cart, so the drawer would only cover it.
                const onCartPage = document.body.classList.contains('template-cart');
                if (window.cartStrings?.uxCart === 'mini-cart' && !onCartPage) {
                    if (this.miniCart) {
                        this.miniCart.classList.add('open');
                    }
                    if (this.overlay) {
                        this.overlay.classList.add('open', 'overlay--all');
                        this.toggleBodyScroll(true);
                        this.toggleEscapeListener(true, this.closeMiniCart.bind(this));
                    }
                }
                
                // Success state
                this.setSuccessState();
                
            } catch (error) {
                console.error('Form submission error:', error);
                this.setLoadingState(false);
            }
        }

        setLoadingState(isLoading) {
            const buttonText = this.submitButton.querySelector('span:not(.cart-icon):not(:empty)');
            const cartIcon = this.submitButton.querySelector('span.cart-icon');
            const loadingIcon = this.submitButton.querySelector('svg.loading-icon');
            
            if (isLoading) {
                // if (buttonText && !this.submitButton.closest('.mini-cart')) {
                //     buttonText.textContent = window.cartStrings?.addingToCart || 'Adding...';
                // }
                this.submitButton.classList.add('added');
                if (cartIcon) cartIcon.style.display = 'none';
                if (loadingIcon) loadingIcon.style.display = 'block';
            } else {
                // if (buttonText) {
                //     buttonText.textContent = window.cartStrings?.addToCart || 'Add to cart';
                // }
                this.submitButton.classList.remove('added');
                if (cartIcon) cartIcon.style.display = 'inline-flex';
                if (loadingIcon) loadingIcon.style.display = 'none';
            }
        }

        setSuccessState() {
            const buttonText = this.submitButton.querySelector('span:not(.cart-icon):not(:empty)');
            const cartIcon = this.submitButton.querySelector('span.cart-icon');
            const loadingIcon = this.submitButton.querySelector('svg.loading-icon');
            
            if (buttonText) {
                buttonText.textContent = window.cartStrings?.addedToCart || 'Added!';
            }
            this.submitButton.classList.remove('added');
            this.submitButton.classList.add('successful');
            if (cartIcon) cartIcon.style.display = 'flex';
            if (loadingIcon) loadingIcon.style.display = 'none';
        }

        showError(errorData) {
            const errorContainer = this.querySelector('.product-converter__error');
            if (!errorContainer) return;
            
            let errorMessage = '';
            
            if (typeof errorData.description === 'object') {
                Object.entries(errorData.description).forEach(([key, value]) => {
                    errorMessage += value.join(', ');
                });
            } else {
                errorMessage = errorData.description;
            }
            
            errorContainer.innerHTML = `<span class="icon loaded">error</span><p>${errorMessage}</p>`;
        }

        clearError() {
            const errorContainer = this.querySelector('.product-converter__error');
            if (errorContainer) {
                errorContainer.innerHTML = '';
            }
        }
        
        disconnectedCallback() {
            if (this.form && this._submitBound) {
                this.form.removeEventListener('submit', this.boundHandleSubmit);
                this._submitBound = false;
            }
        }
    }

    customElements.define('product-form-handler', ProductFormHandler);
}
